import { useLocalization } from 'localization'
import { message } from 'antd'
import { useMutation, useQueryClient } from 'react-query'
import { changePlan, generateCheckoutLink } from './services'
import { ResponseErrorType } from 'types/custom'
import queries from 'api/queries'

export const useCheckout = () => {
	const { t } = useLocalization()

	return useMutation(generateCheckoutLink, {
		onSuccess: link => {
			window.location.href = link
		},
		onError: (error: ResponseErrorType) => {
			if (error?.response?.status !== 401) {
				message.error(t('billings.checkout.error'))
			}
		},
	})
}

export const useChangePlan = () => {
	const { t } = useLocalization()
	const queryClient = useQueryClient()

	return useMutation(changePlan, {
		onSuccess: () => {
			message.success(t('billings.changePlan.success'))
			queryClient.invalidateQueries([queries.current])
		},
		onError: () => {
			message.error(t('billings.changePlan.error'))
		},
	})
}
